// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgSortingIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M9.063 12.8a.813.813 0 0 1-.813-.813V7.06L6.718 8.569a.805.805 0 0 1-1.13-1.148l2.773-2.73a1 1 0 0 1 1.403 0l2.773 2.73a.805.805 0 0 1-1.13 1.148L9.875 7.06v4.928a.813.813 0 0 1-.813.812Zm6.576 6.51a1 1 0 0 1-1.403 0l-2.773-2.731a.805.805 0 0 1 1.13-1.148l1.532 1.509v-4.928a.813.813 0 0 1 1.625 0v4.928l1.532-1.509a.805.805 0 0 1 1.13 1.148z" />
  </g>
);
export default SvgSortingIcon;
SvgSortingIcon.displayName = 'SvgSortingIcon';
